import createDocumentData from "../../utils/createDocumentData";

import { Comment } from "./types/Comment";

export default function createCommentData(firebase, data) {
	return Comment.parse(createDocumentData(firebase, "comments", data));
}
